import { LoadingOutlined } from "@ant-design/icons";
import {
  Spin,
  //  Typography,
} from "antd";

//const { Title, Text} = Typography;

const LoadingScreen = ({ text }) => {
  return (
    <div
      style={{
        textAlign: "center",
        width: "100%",
        height: "100%",
      }}
    >
      <div
        style={{
          marginTop: "5%",
          padding: "2rem",
          display: "inline-block",
          justifyContent: "center",
          flexDirection: "column",
          backgroundColor: "#F4F3EF",
        }}
      >
        <Spin
          indicator={<LoadingOutlined spin />}
          tip={text}
          style={{ width: "100%", height: "100%", marginTop: "1.25rem" }}
        />
      </div>
    </div>
  );
};

export default LoadingScreen;
